export default {
  name: 'calmante-noche',
  label: 'calmante noche',
  formula: [
    {
      name: 'aceite esencial de sándalo',
      quantity: 7.5,
      unit: 'ml',
      ref: 'sandalo'
    },
    {
      name: 'aceite esencial de bergamota',
      quantity: 3.75,
      unit: 'ml',
      ref: 'bergamota'
    },
    {
      name: 'aceite esencial de lavanda',
      quantity: 5,
      unit: 'ml',
      ref: 'lavanda'
    },
  ]
}
